<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{ 'Dates'|translate }}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <span style="width:300px;"><v-text-field class="mr-4" clearable v-model="search" type="text"
                                                             :label="'Keyword filter'|translate"></v-text-field></span>
                    <v-btn class="accent" @click="editedItem=null; dialog=true" :disabled="!$can('update', 'Dates')">
                        <v-icon small class="mr-2">fa-plus</v-icon>
                        {{ 'Add Record'|translate }}
                    </v-btn>
                    <dates-dialog v-model="dialog" :item="editedItem" v-on:doreload="refresh()"></dates-dialog>
                </v-card-actions>

                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="dates"
                        class="elevation-1"
                        :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        :items-per-page="25"
                        :search="search2"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.start_date }}</td>
                            <td>{{ props.item.end_date }}</td>
                            <td>{{ props.item.date_type }}</td>
                            <td>{{ props.item.notes }}</td>
                            <td class="justify-center layout px-0">
                                <v-icon
                                    small
                                    class="mr-2"
                                    v-if="$can('update', 'Dates')"
                                    @click="$can('update', 'Dates') && editItem(props.item)"
                                >
                                    fa-edit
                                </v-icon>
                                <v-icon
                                    small
                                    v-if="$can('delete', 'Dates')"
                                    @click="$can('delete', 'Dates') && deleteItem(props.item)"
                                >
                                    fa-trash
                                </v-icon>
                            </td>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize">{{ 'Reset'|translate }}</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getDates, deleteDates} from '../helper'
import DatesDialog from "../components/DatesDialog";

export default {
    name: 'Dates',
    components: {DatesDialog},
    data() {
        return {
            dialog: false,
            headers: [
                {text: this.$options.filters.translate('Start Date'), value: 'start_date'},
                {text: this.$options.filters.translate('End date'), value: 'end_date'},
                {text: this.$options.filters.translate('Type'), value: 'date_type'},
                {text: this.$options.filters.translate('Notes'), value: 'notes'},
                {text: this.$options.filters.translate('Actions'), value: 'notes', sortable: false},
            ],
            dates: [],
            editedItem: {},
            search: '',
            search2: ''
        }
    },

    mounted() {
        this.initialize()
    },
    watch: {
        search() {
            this.debounce(this.syncSearches, 500);
        }
    },
    methods: {
        initialize() {
            this.refresh()
        },

        editItem(item) {
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },

        async deleteItem(item) {
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?'))) {
                await deleteDates({
                    'date_id': item.date_id
                })
                this.refresh()
            }
        },
        async refresh() {
            let df = await getDates({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name
            })
            this.dates = df['dates']
        },
        syncSearches() {
            this.search2 = this.search
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
    }
}
</script>

<style scoped>

</style>
